module.exports = __webpack_public_path__ + "img/icon-filter.914a3846.svg";